import { render } from "./CreateTripForm.vue?vue&type=template&id=4d8c1426&scoped=true&ts=true"
import script from "./CreateTripForm.vue?vue&type=script&lang=ts"
export * from "./CreateTripForm.vue?vue&type=script&lang=ts"

import "./CreateTripForm.vue?vue&type=style&index=0&id=4d8c1426&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d8c1426"]])

export default __exports__